import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicStorageModule } from '@ionic/storage';
// import { AuthService } from './services/auth.service';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {ComponentsModule} from './components/components.module';
import { PileSaverPageModule } from './components/pile-editor/pile-saver/pile-saver.module';
import { SectorSaverPageModule } from './components/sector-editor/sector-saver/sector-saver.module';
import { PileRenamerPageModule } from './components/pile-editor/pile-renamer/pile-renamer.module';

// import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { NgxChartsModule }from '@swimlane/ngx-charts';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [ComponentsModule,BrowserModule,

    IonicModule.forRoot(), IonicStorageModule.forRoot(),AppRoutingModule],
  providers: [
    // AuthService,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {

}
